export class OpEtap {

    _id:any = undefined
	etap_typ:string=""

	rodzaj_farby:string = ""
	rodzaj_lakieru:string = ""

    grupa_maszyn:string = "" // co DH sobie życzył
	//grupa_maszyn:string    // grupa maszyn przydzielona przez system
    //grupy_maszyn: string[] // lista możliwych grup maszyn

	//predkosc:number; // max prędkość dla etapu

	
}
